import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { logout } from "../../../auth";
import { UserBadgeIcon } from "../../../icons/UserBadgeIcon";
import { FaCaretDown } from "react-icons/fa";
import useSWR from "swr";

const getUsername = () => {
  const { data: me } = useSWR<any>([`/v1/me/`], {
    revalidateOnFocus: false,
  });
  const username = me?.first_name;
  if (username) return username.charAt(0).toUpperCase() + username.slice(1);
  return "AltoTech";
};

export function UserBadge() {
  return (
    <Menu>
      <MenuButton className="flex items-center gap-2 rounded-[20px] px-3 py-[6px] transition-colors hover:bg-primary-extraLight/30 active:bg-primary-extraLight/50 [&[aria-expanded=true]]:bg-primary-extraLight/50">
        <UserBadgeIcon />
        <div className="ml-3 flex flex-col items-start">
          <span className="text-[14px] text-primary font-medium">
            {getUsername()}
          </span>
        </div>
        <span className="ml-6 text-primary">
          <FaCaretDown />
        </span>
      </MenuButton>
      <MenuItems
        transition
        anchor="bottom"
        className="w-[200px] mt-2 bg-white transition duration-100 ease-out shadow-badgelogout [--anchor-gap:var(--spacing-1)] data-[closed]:scale-95 data-[closed]:opacity-0 origin-top-right focus:outline-none
    p-0.5 rounded-[10px]"
      >
        {/* <MenuItem>
            <button className="w-full px-4 py-2 cursor-pointer rounded-lg text-sm flex items-center gap-3 hover:bg-primary/30 &[data-active=true]]:(outline-none hover:ring-1 hover:ring-primary)">
              Change password
            </button>
          </MenuItem> */}
        <MenuItem>
          <button
            className="w-full px-4 py-2 cursor-pointer rounded-lg text-sm flex items-center gap-3 hover:bg-primary/30 &[data-active=true]]:(outline-none hover:ring-1 hover:ring-primary)"
            onClick={logout}
          >
            Logout
          </button>
        </MenuItem>
      </MenuItems>
    </Menu>
  );
}
